import {FC, memo} from "react";

const DateTimeDisplayComponent: FC<{
  value: any,
  type: string,
}> = ({ value, type }) => {
  return (
    <div className="countdown">
      <span className="countdown-value">{value}</span>
      <span>{type}</span>
    </div>
  )
}

export const DateTimeDisplay = memo(DateTimeDisplayComponent)
